import { render, staticRenderFns } from "./MobileCertifi.vue?vue&type=template&id=6ec0d05f&"
import script from "./MobileCertifi.vue?vue&type=script&lang=js&"
export * from "./MobileCertifi.vue?vue&type=script&lang=js&"
import style0 from "./MobileCertifi.vue?vue&type=style&index=0&id=6ec0d05f&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports